import { useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import { useMyHrChangeRequestsBadges } from "my-hr/hooks";
import { useOcCurrentUserState, useOcIsMobile } from "oc/hooks";
import { ocNarrowMenuState } from "states";

export const useMyHrHeaderBadge = (): {
  handleClick: () => void;
  count: number;
} => {
  const history = useHistory();
  const isMobile = useOcIsMobile();
  const [narrowMenuOpened, setNarrowMenuOpened] =
    useRecoilState(ocNarrowMenuState);
  const { contractCode } = useOcCurrentUserState();
  const { data } = useMyHrChangeRequestsBadges(contractCode);

  const handleClick = () => {
    if (isMobile) {
      setNarrowMenuOpened(!narrowMenuOpened);
    }
    history.push("/my-hr/view-requests");
  };

  const count = data ?? 0;

  return {
    handleClick,
    count,
  };
};
